module.exports = __webpack_public_path__ + "static/media/tickets.efdeff0c.pdf";